// Import dependencies
import Cookies from 'js-cookie';
import initialiser from '../../utils/initialiser';

import { getMetaDataCalledEvent, sessionIsInactiveEvent } from '../CreateYourOwnPackage/utils';

const defaultSettings = {
  activeClass: 'is-active',
  activeClassHeader: 'o-section--has-timer',
  timerHeader: '.js-timer-header',
};

class CartTimerManager {
  constructor(config) {
    const { el, settings } = config;

    // Set root element
    this.container = el;

    // Set settings
    this.settings = { ...defaultSettings, ...settings };

    // DOM Elements
    this.cartLink = document.querySelector(this.settings.cartLink);
    this.cartLinkMobile = document.querySelector(this.settings.cartLinkMobile);
    this.cartTimerSelector = document.querySelector(this.settings.selector);
    this.cartTimerPlaceholder = document.querySelector(this.settings.cartTimerPlaceholder);
    this.tnew = this.container.dataset.tnew;
    this.cartCount = document.createElement('strong');
    this.cartCountMobile = document.createElement('strong');
  }

  // Initialisation Function - Called on each component instance intialisation
  init = () => {
    if (!this.container) return;

    // Call bind events
    this.bindEvents();
  };

  bindEvents = () => {
    window.addEventListener('load', () => this.handleCartTimer());
    window.addEventListener('performanceAdded', () => this.getMetaData(Cookies.get('sessionKey')));
    window.addEventListener('performanceRemoved', () => this.getMetaData(Cookies.get('sessionKey')));
  };

  handleCartTimer = () => {
    fetch(this.tnew, {
      mode: 'cors',
      credentials: 'include',
    })
      .then((response) => response.json())
      .then((metaData) => this.getMetaData(metaData.encryptedSessionKey))
      .catch((err) => {
        const errorMessage = document.querySelector('.js-create-your-own-package-sessionkey-error');
        if (errorMessage) errorMessage.classList.remove('u-hide');

        console.error(`Fetch problem: ${err.message}`); // eslint-disable-line
      });
  };

  getMetaData = (sessionKey) => {
    Cookies.set('sessionKey', sessionKey);

    fetch('/tessitura/getMetaData', {
      method: 'get',
      mode: 'cors',
      credentials: 'include',
      headers: new Headers({
        Accept: 'application/json',
        Authorization: `Bearer ${sessionKey}`,
        'Content-Type': 'application/json',
      }),
    }).then((response) => response.json()).then((data) => {
      window.dispatchEvent(getMetaDataCalledEvent);

      if (data.cartCount > 0) {
        this.cartLink.classList.add(this.settings.activeClass);
        this.cartLinkMobile.classList.add(this.settings.activeClass);
        this.container
          .parentElement.querySelector(this.settings.timerHeader)
          .classList.add(this.settings.activeClassHeader);

        this.cartCount.innerHTML = data.cartCount;
        this.cartCountMobile.innerHTML = data.cartCount;

        this.cartLink.insertBefore(this.cartCount, this.cartLink.firstChild);
        this.cartLinkMobile.insertBefore(this.cartCountMobile, this.cartLinkMobile.firstChild);
      }

      if (typeof data.expiration !== 'undefined') {
        this.cartTimerSelector.classList.add(this.settings.activeClass);

        // Update the count down every 1 second
        const x = setInterval(() => {
          // Get today's date and time
          const now = new Date().getTime();

          // Get expiry date and time
          const countDownDate = data.expiration === ''
            ? new Date(now - 1)
            : new Date(data.expiration).getTime();

          // Find the distance between now and the count down date
          const distance = countDownDate - now;

          // Time calculations for days, hours, minutes and seconds
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000).toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false,
          });

          // Display the result in the element with id="demo"
          this.cartTimerPlaceholder.innerHTML = `Your cart expires in ${minutes}:${seconds} minutes`;

          // If the count down is finished, write some text
          if (distance <= 0) {
            clearInterval(x);
            this.cartLink.classList.remove(this.settings.activeClass);
            this.cartLinkMobile.classList.remove(this.settings.activeClass);
            this.cartTimerPlaceholder.innerHTML = '';
          }
        }, 1000);
      } else {
        this.cartLink.classList.remove(this.settings.activeClass);
        this.cartLinkMobile.classList.remove(this.settings.activeClass);
        this.cartTimerPlaceholder.innerHTML = '';
      }

      if (data.activeSession === false) {
        window.dispatchEvent(sessionIsInactiveEvent);
      }
    });
  }
}

// Export component wrapped in initialiser utility
export default (settings) => initialiser(settings, CartTimerManager);
